export default "__VITE_ASSET__BO0QkhI9__"